export default "__VITE_ASSET__Do64wM$Y__"